import currency from 'currency.js';

export const formatToCents = (amount: Parameters<typeof currency>[0]): number =>
    currency(amount).multiply(100).value;
